import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  Activity,
  Briefcase,
  Check,
  ChevronDown,
  Download,
  Eye,
  File,
  Mail,
  Map,
  MapPin,
  PhoneCall,
  Server,
  User,
  Users,
} from "react-feather";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import StatisticsCards from "./StatisticsCards";
import Select from "react-select";
import CommonModal from "../../Components/CommonModal";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PostApiCall from "../../Api/Api";
import maleIcon from "../../assets/profile/user.jpeg";
import femaleIcon from "../../assets/profile/female-icon1.png";
import { useDispatch, useSelector } from "react-redux";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { ToastContainer, toast } from "react-toastify";
import { delay } from "../../Helper/ToastDelay";
import { NotificationAction } from "../../Store/Actions/NotificationAction";
import { StatusAuditNotification } from "../../Helper/NotificationMsg";
import moment from "moment";
import defaultUser from "../../assets/profile/defaultuser.png";
import { DataTable as DataTables } from "primereact/datatable";
import { Column } from "primereact/column";
import CustomDataTable from "../../Components/CustomDataTable";
import Notiflix from "notiflix";
const ManageApplicants = () => {
  const [applicantList, setApplicantList] = useState([]);
  const [applicantfilteredList, setApplicantFilteredList] = useState([]);
  const [searchApplicantList, setSearchApplicantList] = useState("");
  const [filterApplicantList, setSelectedFilterApplicantList] = useState({
    value: "All",
    label: "All",
  });
  const [selectedUser, setSelectedUser] = useState({});
  const [modal, setModal] = useState(false);
  const [jobId, setJobId] = useState(null);
  let columnDefs = [
    {
      field: "fld_code",
      header: "Job Id",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
    {
      field: "fld_title",
      header: "Job Title",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_company",
      header: "Client Name",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_type",
      header: "Type",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
    {
      field: "fld_status",
      header: "Status",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
      body: (row) => (
        <span
          className={`${
            row.fld_status === "Active" ? "GreenWhite" : "OrangeWhite"
          } py-1 px-2`}
        >
          {row.fld_status === "Active" ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      field: "fld_city",
      header: "City",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
    {
      field: "total_applied",
      header: "Total Applicants",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_positions",
      header: "No of Positions",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "action",
      header: "Action",
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
      body: (row) => (
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            const data = JSON.parse(row?.candidatelist);
            setJobId(row?.fld_auditid);
            setModal(true);
            setApplicantList(data);
            setApplicantFilteredList(data);
          }}
        >
          <Eye size={16} /> View
        </span>
      ),
    },
  ];

  const [appliedApplicant, setAppliedApplicant] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState([]);
  const [candidateError, setCandidateError] = useState(false);
  const [recruiterRemarkModal, setRecruiterRemarkModal] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [selectedFilter, setSelectedFilter] = useState({
    value: "All",
    label: "All",
  });
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const user = useSelector((state) => state.login);

  const [applicantAction, setApplicantAction] = useState({
    applicantStatus: null,
    currency: "INR",
    finalPrice: "",
    salaryType: null,
    recruiterRemark: "",
  });

  const handleChange = (key, value) => {
    setApplicantAction((prev) => ({ ...prev, [key]: value }));
  };

  const updateSearchApplicant = (value) => {
    setSearchApplicantList(value);
    filterApplicantData(value, selectedFilter);
  };
  const updateApplicantFilter = (selectedOption) => {
    setSelectedFilterApplicantList(selectedOption);
    filterApplicantData(searchApplicantList, selectedOption);
  };
  const filterApplicantData = (search, filter) => {
    const filtered = applicantList.filter((item) => {
      const searchMatches = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(search.toLowerCase())
      );
      const statusMatches =
        !filter ||
        filter?.value === "All" ||
        item.fld_auditstatus === filter.value ||
        item.fld_auditstatus === filter.value;
      return searchMatches && statusMatches;
    });
    setApplicantFilteredList(filtered);
  };

  const updateFilter = (selectedOption) => {
    setSelectedFilter(selectedOption);
    filterData(searchVal, selectedOption);
  };
  const updateSearchQuery = (value) => {
    setSearchVal(value);
    filterData(value, selectedFilter);
  };

  const filterData = (search, filter) => {
    const filtered = appliedApplicant.filter((item) => {
      const searchMatches = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(search.toLowerCase())
      );
      const statusMatches =
        !filter ||
        filter?.value === "All" ||
        item.fld_status === filter.value ||
        item.fld_status === filter.value;
      return searchMatches && statusMatches;
    });
    setFilteredData(filtered);
  };

  const submitForm = async () => {
    if (applicantAction.applicantStatus) {
      try {
        let Id = selectedCandidate.map((ele) => ele.fld_id).join(",");
        Notiflix.Loading.standard();
        const res = await PostApiCall.postRequest(
          {
            userid: Id,
            auditstatus: applicantAction?.applicantStatus?.value,
            recruiterremark: applicantAction.recruiterRemark,
            auditid: jobId,
            auditorauditstatus: "",
            currency: applicantAction.currency,
            finalsalarytype: applicantAction.salaryType.value,
            finalprice: applicantAction.finalPrice,
          },
          "UpdateJobAuditApplicant"
        );
        const {data}=res.json()

        if (res.ok) {
          toast.success("Status updated successfully", {
            autoClose: delay,
          });
          setRefresh(true);
          setSelectedCandidate([]);

          // const message = StatusAuditNotification(selectedAuditorStatus.value);
          // dispatch(
          //   NotificationAction.addNotification({
          //     ...message,
          //     notificationtype: "Job",
          //     usertype: "user",
          //     senderid: user.fld_id,
          //     receiverid: applicantDetail.fld_candidateid,
          //     updatedat: moment().format("ll"),
          //   })
          // );
        }else{
          throw new Error(data.error)
        }
        Notiflix.Loading.remove();
      } catch (error) {
        toast.error(error.message || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
        Notiflix.Loading.remove();
      }
    }
    setRecruiterRemarkModal(false);
    // else {
    //   toast.warning("User status is already " + updateStatus.value, {
    //     autoClose: delay,
    //   });
    // }
    setModal(false);
    setShowDetailModal(false);
  };

  useEffect(() => {
    (async () => {
      const res = await PostApiCall.postRequest(
        { id: user?.fld_id, usertype: user?.fld_usertype },
        "GetAppliedJobsUser"
      );
      const { data } = await res.json();
      setAppliedApplicant(data);
      setFilteredData(data);
      setRefresh(false);
    })();
  }, [refresh]);

  return (
    <div className="container-fluid">
      <ToastContainer />
      <div className="mb-2"></div>
      <div
        className="p-2 mt-4"
        // style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)", border: "none" }}
      >
        <Row className="filter-actions my-2 justify-content-between">
          <Col sx="12" md="3">
            <Input
              style={{
                border: "#cccccc solid 1px",
                height: "38px",
                borderRadius: "5px",
              }}
              className="mr-1 pt-0 shadow-sm"
              type="text"
              placeholder="search..."
              onChange={(e) => updateSearchQuery(e.target.value)}
              value={searchVal}
            />
          </Col>
          <Col sm="12" md="3" style={{}}>
            <div className="dropdown actions-dropdown" style={{ zIndex: 20 }}>
              <Select
                className="React"
                classNamePrefix="select "
                placeholder="Filter by"
                name="color"
                options={[
                  { value: "All", label: "All" },
                  { value: "Active", label: "Active" },
                  { value: "Inactive", label: "InActive" },
                ]}
                onChange={(selectedOption) => updateFilter(selectedOption)}
                value={selectedFilter}
              />
            </div>
          </Col>
        </Row>
        <CustomDataTable
          data={filteredData}
          columns={columnDefs}
          compact={true} // Enables compact styling
        />
        {/* <DataTable
          highlightOnHover
          className="dataTable-custom mt-2"
          data={filteredData}
          columns={columnDefs}
          fixedHeader
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 25, 50, 100]}
          onRowClicked={(row) => {
            const data = JSON.parse(row?.candidatelist);
            setJobId(row?.fld_auditid);
            setModal(true);
            setApplicantList(data);
            setApplicantFilteredList(data);
          }}
          customStyles={{
            table: {
              style: {
                minHeight: "200px", // Set your desired minimum height
              },
            },
            head: {
              style: {
                background: "transparent", // Remove the default background color
              },
            },
            headRow: {
              style: {
                backgroundColor: "white",
                color: "#ca8636",
              },
            },
            headCells: {
              style: {
                fontSize: "14px",
                textTransform: "capitalize",
              },
            },
          }}
        /> */}
      </div>

      {modal === true && (
        <CommonModal
          isOpen={modal}
          toggle={() => setModal(false)}
          heading={`Applicants List`}
          modalSize={"lg"}
          contentBody={
            <div style={{ marginTop: "0px", zIndex: "50" }}>
              <Row className="filter-actions my-2 justify-content-between">
                <Col sx="12" md="3">
                  <Input
                    style={{
                      border: "#cccccc solid 1px",
                      height: "38px",
                      borderRadius: "5px",
                    }}
                    className="mr-1 pt-0 shadow-sm"
                    type="text"
                    placeholder="search..."
                    onChange={(e) => updateSearchApplicant(e.target.value)}
                    value={searchApplicantList}
                  />
                </Col>
                <Col sm="12" md="3">
                  <div
                    className="dropdown actions-dropdown"
                    style={{ zIndex: 20 }}
                  >
                    <Select
                      className="React"
                      classNamePrefix="select "
                      placeholder="Filter by"
                      name="color"
                      options={[
                        { value: "All", label: "All" },
                        { value: "Pending", label: "Pending" },
                        { value: "Approved", label: "Approved" },
                        { value: "Reviewed", label: "Reviewed" },
                        { value: "Rejected", label: "Rejected" },
                      ]}
                      onChange={(selectedOption) =>
                        updateApplicantFilter(selectedOption)
                      }
                      value={filterApplicantList}
                    />
                  </div>
                </Col>
              </Row>
           
              <DataTables
                highlightOnHover={true}
                value={applicantfilteredList}
                selectionMode={"checkbox"}
                selection={selectedCandidate}
                onSelectionChange={(e) => {
                  setCandidateError(false);
                  setSelectedCandidate(e.value);
                }}
                dataKey="fld_id"
                // tableStyle={{ minWidth: "80rem" }}
                paginator={true}
                rows={5}
                style={{ fontSize: "13px" }}
              >
                <Column
                  selectionMode="multiple"
                  style={{ padding: "10px" }}
                ></Column>
                <Column
                  sortable={true}
                  field="fld_auditstatus"
                  header="Audit Status"
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
                  body={(rowData) => (
                    <div
                      className="text-truncate"
                      style={{ maxWidth: "200px" }}
                    >
                      <span
                        className={`${genareteColor(
                          rowData.fld_auditstatus
                        )} font-size-3 rounded-3 px-2`}
                      >
                        {rowData.fld_auditstatus}
                      </span>
                      {/* {rowData.fld_auditstatus} */}
                    </div>
                  )}
                />

                <Column
                  sortable={true}
                  field="fld_auditorauditstatus"
                  header="Auditor Approval"
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
                  body={(rowData) => (
                    <>
                      {rowData.fld_auditstatus === "Approved" && (
                        <div
                          className="text-truncate"
                          style={{ maxWidth: "200px" }}
                        >
                          {rowData.fld_auditorauditstatus !== "" && (
                            <span
                              className={`${genareteColor(
                                rowData.fld_auditorauditstatus
                              )} font-size-3 rounded-3 px-2`}
                            >
                              {rowData.fld_auditorauditstatus}
                            </span>
                          )}
                          {/* {rowData.fld_auditstatus} */}
                        </div>
                      )}
                    </>
                  )}
                />
                <Column
                  sortable={true}
                  field="fld_name"
                  header="Name"
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px"
                    ,textTransform:"capitalize"
                   }}
                ></Column>

                <Column
                  sortable={true}
                  field="fld_email"
                  header="Email"
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
                ></Column>
                <Column
                  sortable={true}
                  field="fld_mobile"
                  header="Contact"
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
                ></Column>
                <Column
                  sortable={true}
                  field="fld_finalprice"
                  header="Final Price"
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  body={(rowData) => (

                    <>
                    {
                      rowData?.fld_finalprice && 
                    <span>
                      {" "}
                      {rowData?.fld_currency} {rowData?.fld_finalprice} /{" "}
                      {rowData.fld_finalsalarytype}
                    </span>
                    }
                    
                    </>
                  )}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
                ></Column>
                <Column
                  sortable={true}
                  field="fld_presentcity"
                  header="City"
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
                ></Column>
                <Column
                  sortable={true}
                  field="fld_userrating"
                  header="Rating"
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
                ></Column>

                <Column
                  sortable={true}
                  body={(rowData) => (
                    <div
                      className="text-dark"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setShowDetailModal(true);

                        setSelectedUser(rowData);
                      }}
                    >
                      <Eye size={15} /> View
                    </div>
                  )}
                  header="Action"
                  // headerStyle={{ color: "#ca8636" }}
                  headerStyle={{
                    width: "150px",
                    minWidth: "180px",
                    fontSize: "13px",
                  }}
                  bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
                  style={{ width: "150px", cursor: "pointer" }}
                ></Column>
              </DataTables>
              {candidateError && (
                <div className="text-center text-danger">
                  Please select the user to process
                </div>
              )}
            </div>
          }
          onConfirm={() => {
            if (selectedCandidate.length > 0) {
              setCandidateError(false);
              setRecruiterRemarkModal(true);
            } else {
              setCandidateError(true);
            }
          }}
          confirmText={"Process"}
          cancelText={"Cancel"}
          onCancel={() => setModal(false)}
        />
      )}
      {recruiterRemarkModal === true && (
        <CommonModal
          isOpen={recruiterRemarkModal}
          toggle={() => setRecruiterRemarkModal(false)}
          heading={"Applicants Action"}
          contentBody={
            <div style={{ marginTop: "0px" }}>
              <Row>
                <Col sm={12}>
                  <div
                    className="dropdown actions-dropdown my-2"
                    style={{ zIndex: 30 }}
                  >
                    <Label for="nameVertical">
                      Applicant Status <span className="mandatory">*</span>
                    </Label>
                    <Select
                      classNamePrefix="select"
                      placeholder="Select"
                      name="applicantStatus"
                      options={[
                        { value: "Pending", label: "Pending" },
                        { value: "Reviewed", label: "Reviewed" },
                        { value: "Approved", label: "Approved" },
                        { value: "Rejected", label: "Rejected" },
                      ]}
                      onChange={(option) =>
                        handleChange("applicantStatus", option)
                      }
                      value={applicantAction.applicantStatus}
                    />
                  </div>
                </Col>
                <Col md={3} className="my-2">
                  <Label for="nameVertical">
                    Currency <span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="text"
                    value={applicantAction.currency}
                    readOnly
                  />
                </Col>
                <Col md={5} className="my-2">
                  <Label for="nameVertical">
                    Final Price <span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="number"
                    placeholder="Final Price"
                    value={applicantAction.finalPrice}
                    onChange={(e) => handleChange("finalPrice", e.target.value)}
                  />
                </Col>
                <Col md={4} className="my-2">
                  <div
                    className="dropdown actions-dropdown"
                    style={{ zIndex: 20 }}
                  >
                    <Label for="nameVertical">
                      Salary Type <span className="mandatory">*</span>
                    </Label>
                    <Select
                      classNamePrefix="select"
                      placeholder="Select"
                      name="salaryType"
                      options={[
                        { value: "Per Hour", label: "Per Hour" },
                        { value: "Per Day", label: "Per Day" },
                        { value: "Per Week", label: "Per Week" },
                        { value: "Per Month", label: "Per Month" },
                      ]}
                      onChange={(option) => handleChange("salaryType", option)}
                      value={applicantAction.salaryType}
                    />
                  </div>
                </Col>

                <Col sm={12}>
                  <Label for="nameVertical">
                    Recruiter Remarks <span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="textarea"
                    className="w-100 mt-1"
                    placeholder="Message ..."
                    value={applicantAction.recruiterRemark}
                    style={{ height: "100px", paddingLeft: "10px" }}
                    onChange={(e) =>
                      handleChange("recruiterRemark", e.target.value)
                    }
                  />
                </Col>
              </Row>
            </div>
          }
          onConfirm={submitForm}
          confirmText={"submit"}
          cancelText={"Cancel"}
          onCancel={() => setRecruiterRemarkModal(false)}
        />
      )}
      {showDetailModal === true && (
        <CommonModal
          isOpen={showDetailModal}
          toggle={() => setShowDetailModal(false)}
          heading={"User Detail"}
          contentBody={
            <div>
              <div className="d-flex">
                <img
                  src={
                    process.env.REACT_APP_FILE_PATH_URL + selectedUser.fld_photo
                  }
                  alt="User"
                  width={"80px"}
                  height={"80px"}
                  className="shadow"
                  onError={(e) => (e.target.src = maleIcon)}
                />
                <div className="ml-3">
                  <p style={{ color: "black" }}>
                    Name :{" "}
                    <span style={{ color: "gray" }}>
                      {selectedUser.fld_name}
                    </span>
                  </p>
                  <p style={{ color: "black" }}>
                    Email :{" "}
                    <span style={{ color: "gray" }}>
                      {selectedUser.fld_email}
                    </span>
                  </p>
                  <p style={{ color: "black" }}>
                    Phone No :{" "}
                    <span style={{ color: "gray" }}>
                      {selectedUser.fld_mobile}
                    </span>
                  </p>
                  <p style={{ color: "black" }}>
                    City :{" "}
                    <span style={{ color: "gray" }}>
                      {selectedUser.fld_presentcity}
                    </span>
                  </p>
                </div>
              </div>

              <FormGroup>
                <Row>
                  {/* <Col sm="6">
                    <Label htmlFor="">Prices Accepted</Label>
                    <Input
                      type="text"
                      name="name"
                      id="nameVertical"
                      className="rounded-0"
                      value={selectedUser.fld_price === 1 ? "Yes" : "No"}
                      disabled
                    />
                  </Col> */}

                  {selectedUser.fld_purposaldate != "" && (
                    <Col sm="6" className="mt-3">
                      <Label htmlFor="">Proposed Date</Label>
                      <Input
                        type="text"
                        name="name"
                        id="nameVertical"
                        className="rounded-0"
                        value={moment(selectedUser.fld_purposaldate).format(
                          "ll"
                        )}
                        disabled
                      />
                    </Col>
                  )}
                </Row>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="exampleText">Auditor Remarks</Label>
                <Input
                  id="exampleText"
                  name="text"
                  type="textarea"
                  className="py-2"
                  disabled
                  value={selectedUser.fld_auditorremark}
                />
              </FormGroup>
            </div>
          }
          cancelText={"Cancel"}
          onCancel={() => setShowDetailModal(false)}
        />
      )}
    </div>
  );
};

export default ManageApplicants;

{
  /* <Row className="gap-4">
          <Col sm="12">
            <div className="mb-3 text-dark">Job Applicants Status</div>
          </Col>
          <Col lg="3" sm="6">
            <StatisticsCards
              iconRight
              iconBg="primary"
              icon={<Server className="primary " size={20} />}
              stat={appliedApplicant?.length}
              statTitle="Total"
            />
          </Col>
          <Col lg="3" sm="6">
            <StatisticsCards
              iconRight
              iconBg="primary"
              icon={<Activity className="primary" size={20} />}
              stat={getStatusCounts().reject}
              statTitle="Rejected"
            />
          </Col>
          <Col lg="3" sm="6">
            <StatisticsCards
              iconRight
              iconBg="primary"
              icon={<Check className="primary" size={20} />}
              stat={getStatusCounts().approve}
              statTitle="Approved"
            />
          </Col>
          <Col lg="3" sm="6">
            <StatisticsCards
              iconRight
              iconBg="primary"
              icon={<Users className="primary" size={20} />}
              stat={getStatusCounts().pending}
              statTitle="Pending"
            />
          </Col>
        </Row> */
}

{
  /* <div style={{ marginTop: "0px", zIndex: "50" }}>
  <div className="mb-3">
   
    <div className="d-flex align-items-center flex-md-nowrap flex-wrap">

      <div className="avatar avatar-xl mx-auto mr-3">
        <img
          src={
            process.env.REACT_APP_FILE_PATH_URL +
            applicantDetail.fld_photo
          }
          alt="User Image"
          width={"100%"}
          height={"100%"}
          className="shadow"
          onError={(e) => (e.target.src = maleIcon)}
        />
      </div>
      <div className="row ml-md-3">
        <p className="col-12 col-md-6">
          <User size={15} className="text-success" /> :{" "}
          <span className="text-dark" style={{ fontSize: "13px" }}>
            {applicantDetail.fld_name}
          </span>
        </p>

        <p className="col-12 col-md-6">
          <PhoneCall size={15} className="text-success " /> :{" "}
          <span className="text-dark" style={{ fontSize: "13px" }}>
            {applicantDetail.fld_mobile}
          </span>
        </p>
        <p className="col-12 col-md-10">
          <Mail size={15} className="text-success " /> :{" "}
          <span className="text-dark" style={{ fontSize: "13px" }}>
            {applicantDetail.fld_email}
          </span>
        </p>
        <p className="col-12 col-md-10">
          <MapPin size={15} className="text-success " /> :{" "}
          <span className="text-dark" style={{ fontSize: "13px" }}>
            {applicantDetail.fld_location}
          </span>
        </p>
        <p className="col-12 col-md-6">
          <a
            href={
              process.env.REACT_APP_FILE_PATH_URL +
              applicantDetail.fld_resumeurl
            }
            target="__blank"
            className=""
          >
            <File size={15} className="text-success" /> : Resume
          </a>
        </p>
      </div>
    </div>
  </div>

  <FormGroup>
    <Label htmlFor="">
      Select Applicant Status<span className="mandatory">*</span>
    </Label>
    <Select
      className="React"
      classNamePrefix="select"
      name="status"
      onChange={(selectedOption) => {
        setUpdateStatus(selectedOption);
      }}
      options={[
        { value: "Pending", label: "Pending" },
        { value: "Reviewed", label: "Reviewed" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
      ]}
      value={updateStatus}
    />
  </FormGroup>
</div> */
}
